// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"9f27a813","265":"1eb20881","488":"d789a13b","538":"5c9f7d0c"}[chunkId] + ".chunk.js";
};